import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { FormHelperText } from '@material-ui/core';
import { generate } from 'generate-password';
import CommonButton from './CommonButton';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    margin: 0,
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: 'inherit',
  },
}));

const CommonPasswordField = ({ validation, handleChange, userType }) => {
  const classes = useStyles();
  const [password, setPassword] = useState(userType && userType !== 'monitor' ? 'Pass@123' : '123');
  const [visible, setVisibility] = useState(false);

  const autoGeneratePassword = () => {
    const pass = generate({
      length: 8,
      numbers: true,
    })
    setPassword(pass)
    handleChange(pass, 'password')
  }

  const changePassword = (val, field) => {
    setPassword(val)
    handleChange(val, field)
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <FormControl
      error={validation}
      className={clsx(classes.margin, classes.textField)}
      variant="outlined"
      required
    >
      <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
      <OutlinedInput
        id="outlined-adornment-password"
        type={visible ? 'text' : 'password'}
        value={password}
        onChange={(e) => changePassword(e.target.value, 'password')}
        endAdornment={(
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => setVisibility(!visible)}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {visible ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
              )}
        labelWidth={70}
      />
      {validation && validation.length > 0
        ? <FormHelperText id="my-helper-text">{validation[0]}</FormHelperText>
        : null}
      <CommonButton width="col-3" basic color="primary" onClick={autoGeneratePassword}>Generate</CommonButton>
    </FormControl>
  );
}

export default CommonPasswordField;
